import { createContext, useContext, useEffect, useState } from "react";
import { api, BACKEND_URL, LOGO_URL } from "@/lib/api";

const AssetsContext = createContext({ assets: {}, refresh: () => {} });
export const useAssets = () => useContext(AssetsContext);

export function AssetsProvider({ children }) {
  const [assets, setAssets] = useState({});

  const refresh = () => api.get("/assets").then((r) => setAssets(r.data)).catch(() => {});
  useEffect(() => { refresh(); }, []);

  return (
    <AssetsContext.Provider value={{ assets, refresh }}>
      {children}
    </AssetsContext.Provider>
  );
}

// Full URL for an uploaded asset slot, or null.
export function assetUrl(assets, slot) {
  const a = assets?.[slot];
  if (a?.url) return `${BACKEND_URL}${a.url}`;
  return null;
}

// Logo with fallback to the default provided logo.
export function useLogo() {
  const { assets } = useAssets();
  return assetUrl(assets, "logo") || LOGO_URL;
}
